// extracted by mini-css-extract-plugin
export default {"slidesection":"Slides_slidesection__cu-wZ","each-slide-effect":"Slides_each-slide-effect__5NVH1","teachtext":"Slides_teachtext__HAXOI","header":"Slides_header__UghUu"};